import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { RadnoMesto } from './radno-mesto';


@Component({
  selector: 'yt-radno-mesto-modal-update',
  templateUrl: './radno-mesto-modal-update.component.html'
})
export class RadnoMestoModalUpdateComponent 
  extends BaseModalUpdateComponent<RadnoMesto> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RadnoMesto>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
